export default __webpack_public_path__ + "static/media/logo-rmhc.6249f67b.png";